// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const XAI_MODELS = {
	"grok-4.3": {
		id: "grok-4.3",
		name: "Grok 4.3",
		api: "openai-completions",
		provider: "xai",
		baseUrl: "https://api.x.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 30000,
	} satisfies Model<"openai-completions">,
	"grok-4.5": {
		id: "grok-4.5",
		name: "Grok 4.5",
		api: "openai-responses",
		provider: "xai",
		baseUrl: "https://api.x.ai/v1",
		compat: {"supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 6,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 500000,
		maxTokens: 500000,
	} satisfies Model<"openai-responses">,
	"grok-build-0.1": {
		id: "grok-build-0.1",
		name: "Grok Build 0.1",
		api: "openai-completions",
		provider: "xai",
		baseUrl: "https://api.x.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 2,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"openai-completions">,
} as const;
